import { CardCarousel } from '@capsicum/common-web';
import { CARD_WIDTH, type SurveyCardData } from '@capsicum/features/survey/shared';

import { SurveyListCard } from '../survey-list-card/SurveyListCard';

type SurveyCarouselProps = {
	data: Array<SurveyCardData>;
	isLoading?: boolean;
	testID: string;
};

export const SurveyCarousel = ({ data, isLoading, testID }: SurveyCarouselProps) => {
	// TODO: Add skeleton logic and error handling.
	if (isLoading) {
		return null;
	}

	return (
		<CardCarousel cardWidth={CARD_WIDTH} testID={testID} variant="fullWidth">
			{data?.map((cardProps: SurveyCardData, index: number) => (
				<SurveyListCard key={index} testID={`${testID}Card-${cardProps.surveyId}`} {...cardProps} />
			))}
		</CardCarousel>
	);
};
